import React, { useCallback, useEffect } from 'react';
import {
  Character, 
} from "@dndModels";

import API from "@dndUtilities/system_api";

import CharactersInput from '@dndComponents/character/CharactersInput';

const api = API.getInstance();

export default function CharacterIndex() {
  const removeDeletedCharCookies = useCallback(() => {
    // Also remove char cookies for archived characters.
    api.getObjectsOld("character", { owner_id: (api.user ? api.user._id : "No Login") }).then(res => {
      const chars = res as Character[];
      const good_char_ids = chars.filter(o => !o.is_archived).map(o => o._id);
      const items: any = { ...localStorage };
      let bad_item_keys = Object.keys(items).filter(o => o.startsWith("character_"));
      for (const char_id of good_char_ids) {
        bad_item_keys = bad_item_keys.filter(o => !o.startsWith(`character_${char_id}`));
      }

      if (bad_item_keys.length > 0) {
        console.log("Deleting Character Cookies for deleted or archived characters");
        console.log(bad_item_keys);
        for (const key of bad_item_keys) {
          localStorage.removeItem(key);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (api.user) {
      removeDeletedCharCookies();
    }
  }, []);

  if (api.user === null) {
    return (
      <span className="header">You have to log in to use this page.</span>
    );
  } else {
    return (
      <CharactersInput />
    ); 
  } 
}

